import React from 'react'
import { Container } from 'reactstrap'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Header from './HeaderNavbar'
import Footer from './Footer'
import avatar from '../images/avatar.jpeg'

import '../styles/bootstrap.css'
import '../styles/layout.css'
import '../styles/typography.css'
import '../styles/tweets.css'
import '../styles/scroller.css'
import '@fortawesome/fontawesome-svg-core/styles.css'


const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            siteUrl
            description
            keywords
            twitter
            image
          }
        }
      }
    `}
    render={data => {
      //const avatarPath = '../images/' + data.site.siteMetadata.image
      const siteUrl = data.site.siteMetadata.siteUrl
      const siteImageUrl = siteUrl + avatar
      const siteTitle = data.site.siteMetadata.title
      const siteDescription = data.site.siteMetadata.description
      const siteKeywords = data.site.siteMetadata.keywords
      const siteTwitter = data.site.siteMetadata.twitter

      return (
        <div style={{ margin: '0px', padding: '0px' }}>
          <Helmet>
            <html lang="en" />
            <title>{siteTitle}</title>

            {/* General tags */}
            <meta name="description" content={siteDescription} />
            <meta name="image" content={siteImageUrl} />
            <meta name="keywords" content={siteKeywords} />

            {/* OpenGraph tags */}
            <meta property="og:url" content={siteUrl} />
            <meta property="og:type" content="article" />
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={siteDescription} />
            <meta property="og:image" content={siteImageUrl} />

            {/* Twitter Card tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:creator" content={siteTwitter} />
            <meta name="twitter:title" content={siteTitle} />
            <meta name="twitter:description" content={siteDescription} />
            <meta name="twitter:image" content={siteImageUrl} />
          </Helmet>
          <Header siteTitle={siteTitle} />
          <Container fluid> 
            {children}
          </Container>
          <Footer />
        </div>
       )
    }}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
